import styled from "styled-components";
import BaseInput from "../../common/Input";

export const Input = styled(BaseInput)`
  &:active,
  &:focus {
    border-color: ${({ theme }) => theme.styleGuide.colors.suite[500]};
  }
`;
